import {
  Button,
  Divider,
  message,
  Pagination,
  Popconfirm,
  Table,
  Tag,
} from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, FormOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../Utils";
import { deleteBlog, getBlogs } from "./BlogApi";

function Blogs() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPages] = useState();
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  function FetchBlogsData() {
    setIsLoading(true);
    getBlogs(
      `?limit=10&page=${currentPage}${
        search && search.length ? `&search=${search}` : ""
      }`,
    )
      .then((response) => {
        // if (response.status) {
        if (response?.success) {
          setIsLoading(false);
          setUserData(response?.data?.items);
          setTotalPages(response?.data?.pagination?.lastPage);
          setCurrentPage(response?.data?.pagination?.currentPage);
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchBlogsData();
  }, [currentPage, search]);

  function DeleteAction(checked, record) {
    deleteBlog(`${record?.id}`)
      .then((response) => {
        if (response.status) {
          message.open(messageConfiguration("success", response.message, 3));
          FetchBlogsData();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record?.title}
        </p>
      ),
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record?.slug}
        </p>
      ),
    },
    {
      title: "Sport",
      dataIndex: "sport",
      key: "sport",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {record?.sport}
        </p>
      ),
    },

    {
      title: "Created Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "font-dmsans text-sm",
      onCell: () => ({
        style: { padding: 0 },
      }),
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {ExtractDate(record?.createdAt)}.{ExtractTime(record?.createdAt)}
        </p>
      ),
    },

    {
      title: "Updated Time",
      dataIndex: "updatedAt",
      key: "updatedAt",
      className: " font-dmsans text-sm",
      onCell: () => ({
        style: { padding: 0 },
      }),
      render: (data, record) => (
        <p className="text-xs font-dmsans items-center flex justify-center">
          {ExtractDate(record?.updatedAt)}.{ExtractTime(record?.updatedAt)}
        </p>
      ),
    },

    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      align: "center",
      className: "font-dmsans text-sm",
      render: (data) => {
        return (
          <div className="flex justify-center">
            <Tag
              className={`text-xs font-dmsans items-center flex justify-center ${
                data
                  ? "bg-[#996600] text-white border-none p-1 w-[80px]"
                  : "bg-[#cecdcd] text-white border-none p-1 w-[80px]"
              }`}
            >
              {data ? "Active" : "Inactive"}
            </Tag>
          </div>
        );
      },
    },

    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      className: " font-dmsans text-sm",
      render: (data, record) => (
        <div className="items-center flex justify-center ">
          <FormOutlined
            title="Edit"
            className=" font-bold cursor-pointer text-lg text-[#616161] h-[18px] w-4"
            onClick={() =>
              navigate("/blog/add_blog", {
                state: {
                  fill: record,
                  from: "edit",
                },
              })
            }
          />
        </div>
      ),
    },

    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "font-dmsans text-sm",
      render: (data, record) => (
        <div className="items-center flex justify-center ">
          <Popconfirm
            title={
              <div>
                <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                  Are you sure you want to delete this User?
                </p>
              </div>
            }
            onConfirm={() => DeleteAction(undefined, record)}
            okText="Delete"
            cancelText="Cancel"
          >
            <DeleteOutlined className="text-xs font-dmsans" title="Delete" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div className="ml-2 mt-6 mr-2">
        <div className="mb-8 ">
          <Divider
            orientation="left"
            style={{ border: "#cecece" }}
            className="text-base tracking-normal font-dmsans font-normal  text-gray-900"
          >
            Blog Details
          </Divider>
          <div className="flex justify-between items-between gap-3">
            <div className="flex justify-center items-center gap-3">
              <input
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="Type to search... "
                onChange={(e) => setSearch(e.target.value)}
              />
              <button
                class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                type="button"
                onClick={FetchBlogsData}
              >
                Search
              </button>
            </div>
            <div>
              <Button
                onClick={() =>
                  navigate("/blog/add_blog", {
                    state: {
                      fill: null,
                      from: "add",
                    },
                  })
                }
              >
                Add Blog
              </Button>
            </div>
          </div>
        </div>

        <div
          style={{ maxHeight: "620px", overflow: "auto" }}
          className="bg-white"
        >
          <Table
            columns={columns}
            dataSource={userData}
            className="w-screen sm:w-screen"
            loading={isLoading}
            pagination={false}
          />
        </div>
        <Pagination
          className="mt-2  flex justify-center items-center font-inter font-medium text-base w-full  h-[19px] "
          onChange={handlePageChange}
          current={currentPage}
          defaultCurrent={1}
          total={10 * totalPage}
          showSizeChanger={false}
        />
      </div>
    </>
  );
}
export default Blogs;
